module.exports = __webpack_public_path__ + "static/media/38.baca7508.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/unused icon/38.svg
// module id = 423
// module chunks = 14